// สูตรกลาง — ใช้ร่วมกันทั้ง TimestampProjectCost.js (แสดงผลบนจอ), payload ตอนบันทึกเงินเดือน (HrReportV2.js) และ PDF export
// เพื่อไม่ให้ต้องคำนวณ SSO-distribution + total_spent ซ้ำสองที่คนละสูตร (ต้นเหตุยอดไม่ตรงที่เจอมาก่อนหน้านี้)

// ประกันสังคมต่อโครงการ — รวมจากยอดจริงของแต่ละคน (employee_deductions ที่ MergedPayrollTableV2.js คำนวณไว้
// กระจายตามสัดส่วนรายได้ต่อโครงการของคนนั้นเองแล้ว) ไม่ใช้วิธีหารเฉลี่ยยอดรวมทั้งบริษัทตามสัดส่วนค่าแรงโครงการ
// (top-down) แบบเดิมอีกต่อไป เพราะ SSO มีเพดาน (83-875 บาท) ไม่ได้เป็นสัดส่วนตรงกับเงินเดือนเป๊ะ ทำให้ top-down
// คลาดเคลื่อนได้ — ต้องตรงกับ laborProjectReceiptPDF.js เป๊ะ เพราะใช้ employee_deductions แหล่งเดียวกัน
// total_payable ("ที่ต้องจ่าย" ต่อโครงการ) ถูกคำนวณไว้แล้วที่ต้นทาง (MergedPayrollTableV2.js — projectDashboard)
// เหมือน total_bonus/total_salary — แค่ pass ผ่านตรงนี้ ไม่ต้องคำนวณซ้ำ
export function computeProjectCostRows(baseRows) {
  const base = baseRows || [];
  const grandSalary = base.reduce((s, p) => s + (p.total_salary || 0), 0);
  const rows = base.map((p) => {
    const total_sso = Number(
      (p.employee_deductions || []).reduce((s, d) => s + (d.sso || 0), 0).toFixed(2),
    );
    // รวม = ผลรวมต้นทุนจริงของบริษัท — ไม่รวม "หักภาษี" เพราะเป็นเงินที่ตัดมาจากค่าแรงที่นับไปแล้ว
    // (แยกทางจ่ายให้สรรพากรแทนพนักงาน ไม่ใช่ต้นทุนก้อนใหม่) ต่างจากประกันสังคมฝั่งนายจ้างที่เป็นเงินเพิ่มจริง
    const total_spent =
      (p.total_salary || 0) +
      (p.total_ot || 0) +
      (total_sso || 0) +
      (p.total_late || 0) +
      (p.amount || 0) +
      (p.total_allowance || 0) +
      (p.total_field_allowance || 0) +
      (p.total_bonus || 0);
    return { ...p, total_sso, total_spent, total_payable: p.total_payable || 0 };
  });
  return { rows, grandSalary };
}
